// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2opt7","list":"PatternAutocomplete_list__1KnFO"};